import AWS from 'aws-sdk';

// Configure the AWS SDK with your credentials and region
const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,   // Use environment variables for security
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: 'eu-west-1',  // Replace with your S3 region
});

const bucketName = process.env.REACT_APP_S3_BUCKET_NAME; // Your S3 bucket name

// Function to upload a file to S3
export const uploadFileToS3 = async (file, fileName) => {
  const params = {
    Bucket: bucketName, // Your bucket name
    Key: `${fileName}`, // The file path in the bucket
    Body: file, // The file itself
    ContentType: file.type, // Set the content type based on the file type
  };

  try {
    const data = await s3.upload(params).promise(); // Use the AWS SDK upload method
    console.log(`File uploaded successfully. ${data.Location}`);
    return data.Location; // Return the file URL after upload
  } catch (error) {
    console.error('Error uploading file to S3:', error);
    throw error;
  }
};
